module.exports = __webpack_public_path__ + "img/hero-mclaren.c3a43a7.jpg";